import { importProvidersFrom, NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login/login.component';
import { OtpComponent } from './pages/login/otp/otp.component';
import { FormsModule } from '@angular/forms';
import { LoginImageComponent } from './pages/shared/login-image/login-image.component';
import { SidebarComponent } from './pages/shared/sidebar/sidebar.component';
import { NavbarComponent } from './pages/shared/navbar/navbar.component';
import { LayoutComponent } from './pages/layout/layout.component';
import { SharedModule } from './pages/shared/shared.module';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { HttpConfigInterceptor } from './core/configs/httpconfig.interceptor';
import { DatePipe } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Chart, registerables } from 'chart.js';
import { HttpClientModule } from '@angular/common/http';
import { NotFoundComponent } from './pages/shared/not-found/not-found.component';
import { UnauthorizedComponent } from './pages/shared/unauthorized/unauthorized.component';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { UnderConstructionComponent } from './pages/shared/under-construction/under-construction.component';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    OtpComponent,
    LoginImageComponent,
    SidebarComponent,
    NavbarComponent,
    LayoutComponent,
    NotFoundComponent,
    UnauthorizedComponent,
    UnderConstructionComponent
  ],
  imports: [
    BrowserModule,
    TranslateModule,
    AppRoutingModule,
    FormsModule,
    SharedModule,
    HttpClientModule,
    BrowserAnimationsModule,
    DragDropModule
  ],
  providers: [
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [HttpClient]
        },
        defaultLanguage: 'en',
    })
    ]),
    provideHttpClient(withInterceptorsFromDi()),

    provideClientHydration(),
    provideHttpClient(withFetch()),
    provideAnimationsAsync(),
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
